import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    addres_object: '' ,
    kladr_object: '',
    kladr_holder_reg: '',
    year_build: '',
    num_levels: '',
    level: 5,
    square: '',
    num_rooms: '',
    fire: 'Нет',
    material_build: 'Не горючий',
}

export const objectSlice= createSlice({
    name: 'object',
    initialState,
    reducers: {
        setAddresObject: (state, action) => {
            state.addres_object = action.payload
        },
        setKlAdrObj: (state, action) => {
            state.kladr_object = action.payload
        },
        setKlAdrHolderReg: (state, action) => {
            state.kladr_holder_reg = action.payload
        },
        setYearBuild: (state, action) => {
            state.year_build = action.payload
        },
        setNumLevels: (state, action) => {
            state.num_levels = action.payload
        },
        setLevel: (state, action) => {
            state.level = action.payload
        },
        setSquare: (state, action) => {
            state.square = action.payload
        },
        setNumRooms: (state, action) => {
            state.num_rooms = action.payload
        },
        setFire: (state, action) => {
            state.fire = action.payload
        },
        setMaterialBuild: (state, action) => {
            state.material_build = action.payload
        }
    }
    })

export const {
    setAddresObject,
    setKlAdrHolderReg,
    setFire,
    setKlAdrObj,
    setLevel,
    setMaterialBuild,
    setNumLevels,
    setNumRooms,
    setSquare,
    setYearBuild
} = objectSlice.actions

export const selectAddresObject = (state) => state.object.addres_object
export const selectKlAdrHolderReg = (state) => state.object.kladr_holder_reg
export const selectFire = (state) => state.object.fire
export const selectKlAdrObj = (state) => state.object.kladr_object
export const selectLevel = (state) => state.object.level
export const selectMaterialBuild = (state) => state.object.material_build
export const selectNumLevels = (state) => state.object.num_levels
export const selectNumRooms = (state) => state.object.num_rooms
export const selectSquare = (state) => state.object.square
export const selectYearBuild = (state) => state.object.year_build

export default objectSlice.reducer